@let tenant = tenantStore.currentTenant();
@if ((tenantStore.hasNoTenant() || (tenant && !tenant.configuration.onboardingCompleted)) && !tenantStore.initializing()) {
  <app-onboarding></app-onboarding>
}

<mat-drawer-container class="mat-elevation-z0" hasBackdrop="true" (backdropClick)="requestDrawerClose()">
  <mat-drawer class="mat-elevation-z0 right-drawer" mode="over" position="end"
    [disableClose]="true" [opened]="rightSliderService.open()"
    (mousedown)="$event.stopPropagation()">
    <ng-container #dynamicContainer></ng-container>
  </mat-drawer>

  <mat-drawer-content class="page-drawer-content">
    @if (tenant && tenant.configuration.onboardingCompleted) {
      <div class="home-page">
        @if (layout.isHandset() && menuStateService.mobileOpen()) {
          <div class="menu-backdrop" (click)="menuStateService.closeMobileMenu()"></div>
        }
        <div class="sidenav-wrapper" [class.mobile-open]="menuStateService.mobileOpen()"
          [style.width.px]="layout.isHandset() ? null : menuStateService.state().width">
          <div class="menu-container">
            <app-main-menu class="h-100"></app-main-menu>
          </div>
        </div>
        <div class="main-container"
          [style.margin-left.px]="layout.isHandset() ? null : menuStateService.state().width - 10">
          <!-- Single scroll container for every routed page, both axes. The inner
               .page-scroll-content restores the column layout: the library moves
               projected content into its own viewport, which is a plain block box.
               Sous 960px, l'axe X est verrouillé : tableaux et onglets défilent dans
               leur propre conteneur. -->
          <overlay-scrollbars #pageScroll class="page-scroll-host"
            [options]="layout.isHandset() ? pageScrollOptionsHandset : pageScrollOptions">
            <div class="page-scroll-content">
              <app-topbar></app-topbar>
              @if (pageOpen()) {
                <router-outlet></router-outlet>
              }
            </div>
          </overlay-scrollbars>
        </div>
      </div>
    } @else if (tenantStore.loadError(); as error) {
      <app-error-state class="workspace-load-error" size="page" [error]="error" (retry)="tenantStore.retry()"></app-error-state>
    }
  </mat-drawer-content>

</mat-drawer-container>

<!-- Floating action rail of the right drawer. Kept outside <mat-drawer-container>
     because the container only projects <mat-drawer> and <mat-drawer-content>, so
     any other child of it is dropped from the DOM (see home.component.scss). -->
<app-right-drawer-rail
	[opened]="rightSliderService.open()"
	[canGoBack]="rightSliderService.canGoBack()"
	[canComment]="canNavigateToComment()"
	[canGoBackView]="isDrawerViewOpen"
	[unreadComments]="unreadCommentsNotifications"
	[commentsCount]="commentsCountNotifications"
	(closed)="requestDrawerClose()"
	(wentBack)="rightSliderService.back()"
	(wentBackView)="leaveDrawerView()"
	(commentsToggled)="toggleDrawerComments()"></app-right-drawer-rail>
